<div class="content-cell">
    <kve-editor-input-header [title]="title" [toolTip]="toolTip"></kve-editor-input-header>
    <div class="content-cell">
        <nb-stepper #stepper orientation="horizontal" kvActiveStepperText (stepChange)="handleStepChange($event)" [linear]="linearMode">
            <nb-step [label]="labelOne" [stepControl]="gridNameForm">
                <ng-template #labelOne>Set grid name</ng-template>
                <div class="content-cell bordered centered">
                    <form [formGroup]="gridNameForm" (ngSubmit)="onSubmitName()">
                        <div class="form-group halfWidth">
                            <div class="label-custom">Grid Name.</div>
                            <div class="form-control-field"><input nbInput fieldSize="small" fullWidth  formControlName="gridName"/></div>
                            <div class="form-control-submit"><button nbButton status="primary" size="small" (click)="setStepComplete()" [disabled]="!gridNameForm.valid">Submit</button></div>
                        </div>
                    </form>
                    <div class="field-info">Grid name is not published and is only used for identification purposes.  You can use any name, such as "Home Page Grid 1" etc.</div>
                </div>
            </nb-step>
            <nb-step [label]="labelTwo" [stepControl]="gridLayoutForm">
                <ng-template #labelTwo>Select Grid Layout</ng-template>
                <div class="content-cell bordered centered">
                    <div class="option-text">Choose number of cells for the grid.</div>
                        <nb-tabset>
                            <nb-tab tabTitle="2">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>2 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple two cell layout.  Cells are of equal width and landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[0])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[0]" [edit]="false" #2cell ></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="3">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>3 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple three cell layout.  Cells are of equal width and portrait orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[1])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[1]" [edit]="false" #3cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="4">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>4 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple four cell layout.  Cells are of equal width and portrait landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[2])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[2]" [edit]="false" #4cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="5">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>5 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Five cell mixed layout.  1 Large portrait, 3 smaller portraits and a large landscape.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[3])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[3]" [edit]="false" #5cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="6">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>2 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple two cell layout.  Cells are of equal width and portrait landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[4])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[4]" [edit]="false" #6cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="7">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>2 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple two cell layout.  Cells are of equal width and portrait landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[5])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[5]" [edit]="false" #7cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="8">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>2 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple two cell layout.  Cells are of equal width and portrait landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[6])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[6]" [edit]="false" #8cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                            <nb-tab tabTitle="9">
                                <div class="description-sample">
                                    <div class="description">
                                        <h4>2 Cell Grid</h4>
                                        <div class="two-block">
                                            <div class="block-1">Simple two cell layout.  Cells are of equal width and portrait landscape orientation.</div>
                                            <div class="select-button block-2">
                                                <form [formGroup]="gridLayoutForm" (ngSubmit)="onSubmitLayout()">
                                                    <button nbButton size="small" status="primary" (click)="selectGridLayout(defaultData[7])">Use this layout</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="sample">
                                        <ngx-grid-renderer [data]="defaultData[7]" [edit]="false" #9cell></ngx-grid-renderer>
                                    </div> 
                                </div>
                            </nb-tab>
                        </nb-tabset>
                </div>
            </nb-step>
            <nb-step [label]="labelThree">
                <ng-template #labelThree>Add Grid Content</ng-template>
                <div class="content-cell bordered centered">
                    <ng-container *ngIf="isSelected;else selectInstruction">
                        <!-- <ng-container *ngFor="let contentEnum of contentEnums | keyvalue"> -->
                            <div class="option-text">
                                <nb-actions>
                                    <nb-action disabled class="header">
                                        Select content template for cell
                                    </nb-action>
                                    <nb-action size="tiny" *ngFor="let contentEnum of contentEnums | keyvalue" (click)="open(contentEnum)">
                                        {{ contentEnum.value}}
                                    </nb-action>
                                </nb-actions>
                            </div>
                            <!-- <button nbButton outline status="primary">{{ contentEnum.value}}</button> -->
                        <!-- </ng-container> -->
                        <!-- <div class="option-text">Editing Selected Cell.</div> -->
                    </ng-container>
                    <ng-template #selectInstruction>
                        <div class="option-text">Select Cell to edit.</div>
                    </ng-template>
                    <span [ngSwitch]="selectedTemplate">
                        <div *ngSwitchCase="'3'">
                            <div class="grid-3">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'4'">
                            <div class="grid-4">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'5'">
                            <div class="grid-5">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                                <div class="e" [ngClass]="selectedCell?.className == 'e' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('e')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'6'">
                            <div class="grid-6" #grid_6>
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                                <div class="e" [ngClass]="selectedCell?.className == 'e' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('e')">Edit Cell</button>
                                </div>
                                <div class="f" [ngClass]="selectedCell?.className == 'f' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('f')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'7'">
                            <div class="grid-7">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                                <div class="e" [ngClass]="selectedCell?.className == 'e' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('e')">Edit Cell</button>
                                </div>
                                <div class="f" [ngClass]="selectedCell?.className == 'f' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('f')">Edit Cell</button>
                                </div>
                                <div class="g" [ngClass]="selectedCell?.className == 'g' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('g')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'8'">
                            <div class="grid-8">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                                <div class="e" [ngClass]="selectedCell?.className == 'e' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('e')">Edit Cell</button>
                                </div>
                                <div class="f" [ngClass]="selectedCell?.className == 'f' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('f')">Edit Cell</button>
                                </div>
                                <div class="g" [ngClass]="selectedCell?.className == 'g' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('g')">Edit Cell</button>
                                </div>
                                <div class="h" [ngClass]="selectedCell?.className == 'h' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('h')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'9'">
                            <div class="grid-9">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                                <div class="c" [ngClass]="selectedCell?.className == 'c' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('c')">Edit Cell</button>
                                </div>
                                <div class="d" [ngClass]="selectedCell?.className == 'd' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('d')">Edit Cell</button>
                                </div>
                                <div class="e" [ngClass]="selectedCell?.className == 'e' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('e')">Edit Cell</button>
                                </div>
                                <div class="f" [ngClass]="selectedCell?.className == 'f' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('f')">Edit Cell</button>
                                </div>
                                <div class="g" [ngClass]="selectedCell?.className == 'g' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('g')">Edit Cell</button>
                                </div>
                                <div class="h" [ngClass]="selectedCell?.className == 'h' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('h')">Edit Cell</button>
                                </div>
                                <div class="i" [ngClass]="selectedCell?.className == 'i' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('i')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchDefault>
                            <div class="grid-2">
                                <div class="a" [ngClass]="selectedCell?.className == 'a' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('a')">Edit Cell</button>
                                </div>
                                <div class="b" [ngClass]="selectedCell?.className == 'b' ? 'selectedCell': 'unselectedCell'">
                                    <button nbButton outline  size="tiny" status="primary" (click)="selectGridCell('b')">Edit Cell</button>
                                </div>
                            </div>
                        </div>
                    </span>
                    <!-- <div>
                        <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
                        <div class="file-upload">
                            
                            <button nbButton status="primary" (click)="fileUpload.click()" size="tiny"><nb-icon icon="upload-outline"></nb-icon>{{fileName || "No file uploaded yet."}}</button>
                        </div>
                    </div> -->
                </div>
            </nb-step>
        </nb-stepper>   
    </div>
</div>
